import { Logger } from '@/shared/logger/logger';

export const DictUtils = {
  areDictsEqual(
    dict1: Record<string, string>,
    dict2: Record<string, string>,
  ): boolean {
    if (
      !dict1 ||
      !dict2 ||
      Object.keys(dict1).length !== Object.keys(dict2).length
    ) {
      return false;
    }
    const keys1 = Object.keys(dict1);
    const keys2 = Object.keys(dict2);

    // Check if all key-value pairs in dict1 are in dict2
    for (const key of keys1) {
      if (dict2[key] !== dict1[key]) {
        return false;
      }
    }

    // Check if all key-value pairs in dict2 are in dict1
    for (const key of keys2) {
      if (dict1[key] !== dict2[key]) {
        return false;
      }
    }

    return true;
  },
  ObjectToDict(arg0: URLSearchParams) {
    try {
      return Object.fromEntries((arg0 as any).entries());
    } catch (error) {
      Logger.error('Error in ObjectToDict', error);
      return {};
    }
  },
  validateAndFixStringArrayDict<
    T extends {
      iqpar?: Record<string, string[] | string>;
      qpar?: Record<string, string[] | string>;
    },
  >(data: T, fieldName: keyof T = 'qpar' as keyof T): T {
    if (!data[fieldName]) {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      data[fieldName] = {} as T[keyof T];
      return data;
    }

    const fixedDict: Record<string, string[]> = {};
    let needsFix = false;

    for (const [key, value] of Object.entries(
      data[fieldName] as Record<string, any>,
    )) {
      if (typeof value === 'string') {
        fixedDict[key] = [value];
        needsFix = true;
      } else if (Array.isArray(value)) {
        fixedDict[key] = value;
      } else {
        Logger.warn(
          `Invalid ${String(fieldName)} value for key ${key}:`,
          value,
        );
        fixedDict[key] = [];
        needsFix = true;
      }
    }

    if (needsFix) {
      Logger.debug(
        `Fixed ${String(fieldName)} format from string to string[]:`,
        fixedDict,
      );
      data[fieldName] = fixedDict as T[keyof T];
    }

    return data;
  },
};
// // Example usage:
// const dict1 = { a: "hello", b: "world" };
// const dict2 = { a: "hello", b: "world" };
// const dict3 = { a: "hello", c: "everyone" };

// console.log(areDictsEqual(dict1, dict2)); // Output: true
// console.log(areDictsEqual(dict1, dict3)); // Output: false
